import {
  HistoricQuoteWithRiskYieldStatistics,
  ShowHistoricQuoteIntervalEnum,
  useShowHistoricQuote,
} from "@bn/api/apiv1";
import { UseQueryExtendedOptions } from "@bn/api";
import { HistoricQuote, HistoricQuoteParams } from "@api";
import { QUOTE_PROVIDERS } from "@constants";

export const useInvestmentHistoricQuotes = (
  params: Partial<HistoricQuoteParams>,
  options?: UseQueryExtendedOptions<
    HistoricQuoteWithRiskYieldStatistics,
    AxiosApiError,
    HistoricQuoteWithRiskYieldStatistics
  >
) => {
  const query = useShowHistoricQuote(
    {
      quoteProvider: QUOTE_PROVIDERS.ariva,
      tickerSymbol: params.tickerSymbol!,
      from: params.from,
      to: params.to,
      interval: params.interval as ShowHistoricQuoteIntervalEnum, //TODO: Remove once swagger is updated to show day interval
      convertToCurrency: params.convertToCurrency,
    },
    {
      ...options,
      enabled: Boolean(params.tickerSymbol) && options?.enabled !== false,
    }
  );

  return {
    ...query,
    data: (query.data?.historicQuotes ?? []) as HistoricQuote[],
  };
};
